import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"Index\"}}\n\n{{outlet}}\n",{ moduleName: "seshy/templates/authenticated/projects/show/project-versions/index.hbs" })